import { Component, computed, Input } from '@angular/core';
import { FunctionalApproval } from '@lendiodevs/lendio-js-utilities/dist/calculator/functional-approval';
import {
  ApprovalAttributeDisplayTypes,
  DynamicApprovalAttribute,
  DynamicApprovalAttributeTypes
} from '@lendiodevs/lendio-js-utilities/dist/calculator/types/approval-attribute';
import { DiscreteSliderModule } from 'ng2-app/components/discrete-slider/discrete-slider.module';
import { RestrictedInputModule } from 'ng2-app/components/restricted-input/restricted-input.module';
import { RestrictedRadioModule } from 'ng2-app/components/restricted-radio/restricted-radio.module';
import { RestrictedSliderModule } from 'ng2-app/components/restricted-slider/restricted-slider.module';

@Component({
  selector: 'app-approval-attribute-input',
  imports: [
    RestrictedInputModule,
    RestrictedSliderModule,
    RestrictedRadioModule,
    DiscreteSliderModule,
  ],
  templateUrl: './approval-attribute.component.html'
})
export class ApprovalAttributeInputComponent {
  @Input() functionalApproval: FunctionalApproval;
  @Input() set attribute(attribute: DynamicApprovalAttribute) {
    this._attribute = attribute;
  }
  get attribute(): DynamicApprovalAttribute {
    return this.functionalApproval.attributesMap[this._attribute.alias] as DynamicApprovalAttribute;
  }
  _attribute: DynamicApprovalAttribute;
  @Input() disabled: boolean = false;

  readonly DynamicApprovalAttributeTypes = DynamicApprovalAttributeTypes;
  readonly ApprovalAttributeDisplayTypes = ApprovalAttributeDisplayTypes;

  labeledOptions = computed(() => this.attribute.options);

  numericOptions = computed(() => this.attribute.options as number[]);

  shouldBeDisabled = computed(() => this.disabled || (this.attribute.currentBoundaries?.min === this.attribute.currentBoundaries?.max));

  shouldShowSlider = computed(() => {
    const boundaries = this.attribute.currentBoundaries || this.attribute.globalBoundaries;
    return boundaries?.min !== boundaries?.max;
  });

  onChange(value) {
    this.functionalApproval.setAttributeValue(this.attribute.alias, value);
    this.functionalApproval.calculate();
  }
}
